<template>
  <div id="configurator">
    <h3 class="text-align">
      Dein Auto verkaufen - in <span class="highlight">5</span> einfachen Schritten
    </h3>
    <div class="configurator-presentation-steps">
      <div class="pr-step">
        <div class="pr-step-number">
          1
        </div>
        <div class="pr-step-label">
          Schnellbewertung erhalten durch Eingabe deiner Fahrzeugdaten.
        </div>
      </div>
      <div class="pr-step">
        <div class="pr-step-number">
          2
        </div>
        <div class="pr-step-label">
          Preis wird dir direkt per E-Mail zugesendet.
        </div>
      </div>
      <div class="pr-step">
        <div class="pr-step-number">
          3
        </div>
        <div class="pr-step-label">
          Zustand beschreiben, Fotos hochladen und weitere Daten angeben.
        </div>
      </div>
      <div class="pr-step">
        <div class="pr-step-number">
          4
        </div>
        <div class="pr-step-label">
          Du entscheidest, ob du zum Wunschpreis verkaufen möchtest.
        </div>
      </div>
      <div class="pr-step">
        <div class="pr-step-number">
          5
        </div>
        <div class="pr-step-label">
          Zum Höchstgebot verkaufen <br>und Auto kostenlos abholen <br>lassen.
        </div>
      </div>
    </div>

    <div id="configurator-box" class="wrapper">
      <div class="inner-wrapper">
        <div id="configurator-header">
          <h2>Fahrzeugbewertung durchführen</h2>
          <a href="#" class="configurator-back" @click.prevent="backState" v-wave="{color: '#005252',initialOpacity: 0.5,easing: 'ease-in'}" title="Back">
            <!-- <i class="material-icons">chevron_left</i> -->
            <i class="fas fa-angle-left"></i>
          </a>
          <a href="#" @click.prevent="resetState" class="configurator-restart"  tabindex="-1" v-bind:class="{ inactive: isPristine }" v-wave="{color: '#005252',initialOpacity: 0.5,easing: 'ease-in'}" title="Neu starten">
            Neu starten
          </a>
        </div>
        <div id="configurator-content">
          <div id="configurator-container" v-bind:style="{ transform: leftShift() }">
            <!-- <div class="highlight-block" :style="{ 'width':'240px', 'height': '300px', 'background':'green', 'position':'absolute', left: leftShift() }"></div> -->
            <ConfiguratorStep name="make"       size="1x" title="Marke" priority="Audi,BMW,VW,Mercedes Benz,Opel" :class-name="this.$store.state.step === 'make' ? 'current' : ''" />
            <ConfiguratorStep name="model"      size="1x" title="Modell" :class-name="this.$store.state.step === 'model' ? 'current' : ''" />
            <ConfiguratorStep name="year"       size="1x" title="Erstzulassung (Jahr)" :class-name="this.$store.state.step === 'year' ? 'current' : ''" />
            <ConfiguratorStep name="month"      size="1x" title="Erstzulassung (Monat)" :class-name="this.$store.state.step === 'month' ? 'current' : ''" />
            <ConfiguratorStep name="bodytype"   size="1x" title="Fahrzeugtyp" :class-name="this.$store.state.step === 'bodytype' ? 'current' : ''" />
            <ConfiguratorStep name="fuel"       size="1x" title="Kraftstoff" :class-name="this.$store.state.step === 'fuel' ? 'current' : ''" />
            <ConfiguratorStep name="power"      size="1x" title="Leistung" :class-name="this.$store.state.step === 'power' ? 'current' : ''" />
            <ConfiguratorStep name="engine"     size="1x" title="Motor" :class-name="this.$store.state.step === 'engine' ? 'current' : ''" />
            <ConfiguratorStep name="equipment"  size="1x" title="Variante" :class-name="this.$store.state.step === 'equipment' ? 'current' : ''" />
            <ConfiguratorStep name="extras"     size="1x" title="Ausstattung" :class-name="this.$store.state.step === 'extras' ? 'current' : ''" />
            <ConfiguratorStep name="mileage"    size="1x" title="Kilometerstand" :class-name="this.$store.state.step === 'mileage' ? 'current' : ''" />
            <ConfiguratorStep name="purpose"    size="1x" title="Grund deiner Bewertung?" :class-name="this.$store.state.step === 'purpose' ? 'current' : ''" />
            <ConfiguratorStep name="email"      size="4x" title="Letzter Schritt" />
            <ConfiguratorStep name="valuation"  size="4x" title="Berechne …" :class-name="this.$store.state.step === 'valuation' ? 'current' : ''" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from '../services/api'
import ConfiguratorStep from './ConfiguratorStep'
import { Flow } from '../services/flow'
import $ from 'jquery'

export default {
  name: 'Configurator',
  components: { ConfiguratorStep },
  data: function() {
    return {}
  },
  computed: {
    isPristine: function() {
      return this.$store.state.pristine;
    },
  },
  methods: {
    resetState: function() {
        this.$store.commit("reset");
        Api.get(this.$store, this.$store.state.step);
    },
    backState: function(event) {
      event.preventDefault();
      let prevStep = Flow.prev(this.$store.state.step);
      this.$store.commit("updateStep", prevStep);
    },
    leftShift: function() {
      const step = this.$store.state.step
      if($("#step-"+ step).offset()) {
        const element = $("#step-"+ step);

        const containerWidth = parseInt($("#configurator-content").width());
        const elementOffset  = parseInt($(element).position().left);

        let shift = "0";
        if(elementOffset >= containerWidth) {
          shift = ($(element).width() - (containerWidth - elementOffset)) * -1;
        }

        return "translateX("+ shift + "px)";
      } else {
        return "translateX(0px)";
      }
    },
    shiftStepOnOpen() {
      const step = this.$store.state.step;
      if($("#step-"+ step).position() && $("#step-"+ step).position().left && $(window).width() < 800) {
        const shift = $("#step-"+ step).position().left - 0.09 * $("#step-"+ step).position().left;
        $('#configurator-container').css("transform", "translateX(-"+shift+"px)");
      } else if($("#step-"+ step).position() && $("#step-"+ step).position().left && $(window).width() < 1200) {
        $('#configurator-container').css("transform", "translateX("+(- $("#step-"+ step).position().left + 0.09 * $("#step-"+ step).position().left + 240)+"px)");
      } else {
        $('#configurator-container').css("transform", "translateX(0px)");
      }
    }
  },
  mounted: function() {
    this.shiftStepOnOpen();
    Api.get(this.$store, this.$store.state.step);
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

.configurator-presentation-steps {
  display: none;
  height: auto;
  max-width: 1620px;
  width: 1620px;
  margin: 0 auto;
  padding:26px $base-gap 0;
  margin-bottom:25px;
  @include breakpoint(fromgiant) { 
    display: flex;
    justify-content: space-between;
    margin-bottom:40px;
    width: 100%;
  }
  @media screen and (min-width:1200px) and (max-height:850px) {
    margin-bottom:20px;
  }
  @media screen and (min-width:1200px) and (max-height:750px) {
    padding-top:10px;
  }
  .pr-step {
    // width: 33.3%;
    width:20%;
    display: flex;
    align-items: flex-start;

    &:last-of-type {
      .pr-step-label {
        padding-right:0;
      }
    }
    .pr-step-label {
      color: #1a1919;
      font-size: 16px;
      font-style: normal;
      letter-spacing: normal;
      line-height: normal;
      text-align: left;
      width:calc(100% - 62px);
      padding-right:10px;

      @include breakpoint(extralarge) {
        padding-right:20px;
      }
      .red {
        color: $red;
      }

      br {
        display:none;

        @include breakpoint(full) {
          display:block;
        }
      }
    }
    .pr-step-number {
      color: $white;
      font-size: 18px;
      line-height:28px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: normal;
      text-align: center;
      margin-right: 15px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $black-variant;
      border-radius: 55px;
      @include breakpoint(fromgiant) { 
        width: 47px;
        height: 47px;
      }
    }
  }
}

#configurator {
  padding: 0;
  position:relative;

  h3 {
    display:none;
    @include breakpoint(fromgiant) {
      display:block;
    }

    span.highlight {
      display:inline;
      font-size:inherit;
      line-height:inherit;
      font-weight: inherit;
    }
  }
}

#configurator-box.wrapper {
  background: #fff;
	width: 300px;
	height: auto;
	margin-left:auto;
  margin-right:auto;
	border-radius: 15px;
  position: relative;

  @include breakpoint(fromgiant) {
    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
  }
}

@media screen and (max-height:900px) {
  #configurator-box.wrapper {
    max-height: 95vh;
  }
}

@include breakpoint(frommediumlarge) {
  #configurator-box.wrapper {
    width: 720px;
    
  }
}


@include breakpoint(fromgiant) {
  #configurator-box.wrapper {
    width: 100%;
    max-width: 1210px;
    
  }
}

@include breakpoint(fromgiant) {


  #configurator-box.wrapper {
    height: auto;
    width: 1058px;
    padding: 15px;
    // margin-bottom: 40px;
    .inner-wrapper {
      background: #f2f2f2;
      border-radius: 3px;
      height: 100%;
      padding: 35px 35px 55px;
    }
  }
}

@include breakpoint(extralarge) {
  #configurator-box.wrapper, #step-email {
    width: 1210px;
  }
}

@media screen and (min-width:1200px) and (max-height:1100px) {
  #configurator-box.wrapper {

    height:580px;
    .inner-wrapper {
      padding-bottom:30px;
    }
  }
}

@media screen and (min-width:1200px) and (max-height:850px) {
  #configurator-box.wrapper {

    height:520px;
    .inner-wrapper {
      padding:0 35px 30px;
    }
  }
}

@media screen and (min-width:1200px) and (max-height:750px) {
  #configurator-box.wrapper {

    height:420px;
    .inner-wrapper {
      padding:0 35px 30px;
    }
  }
}

#configurator-header {
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	padding: 20px;
	text-align: center;
	border-bottom: 1px solid #d8d8d8;
  @include breakpoint(frommediumlarge) {
    margin: 0;
  }
  @include breakpoint(fromgiant) {
    border:none;
    margin-bottom:25px;
    padding-top: 10px;
  }

  @media screen and (min-width:1200px) and (max-height:1100px) {
    margin-bottom:0;
    padding-bottom:10px;
  }
}

#configurator-header h2 {
  font-family: "Asap", sans-serif;
	margin: 0;
	padding: 0;
	color: #1a1919;
	font-size: 18px;
	font-weight: 700;
  // margin-bottom:10px;
  @include breakpoint(fromgiant) {
    color: #1a1919;
    font-size: 30px;
    margin-bottom:0;
  }
}

#configurator-content {
  overflow: hidden;
  // height: auto;

  @media screen and (min-width:1200px) and (max-height:1100px) {
    height:450px;
  }

  @media screen and (min-width:1200px) and (max-height:850px) {
    height:400px;
  }

  @media screen and (min-width:1200px) and (max-height:750px) {
    height:300px;
  }
}

#configurator-container {
	width: 10000px;
	overflow: hidden;
  transition: all 0.25s ease-in-out;

  -webkit-transform: translateX(0px);
          transform: translateX(0px);
}

.configurator-back {
  display: inline-block;
  top:5px;
  height: 36px;
  width: 36px;
  text-align: center;
  border: 1px solid #d8d8d8;
  border-radius: 23px;
  margin-right: 10px;
  color: #1a1919;

  i { font-size: 24px; vertical-align: middle; top: 3px; }


  @include breakpoint(fromgiant) {
    display: none;
  }
  &:hover {
    // border-color: $green;
    // background: $green;
    // color: #fff;
  }
}



.configurator-restart {
  cursor: pointer;
  border: 1px solid #d8d8d8;
  color: #1a1919;
  font-weight: 400;
  font-size: 13px;
  border-radius: 23px;
  padding: 10px 10px;
  position: relative;
  background: transparent;
  top: 8px;

  &.inactive {
    transition: .2s;
    color: $inactive-gray;
    pointer-events: none;
  }

  @include breakpoint(fromgiant) {
    position: absolute;
    right: 0px;
    top: 3px;
    font-size: 16px;
    padding: 12px 20px;
  }

  @media screen and (min-width:1200px) and (max-height:850px) {
    top: 10px;
  }
}

.configurator-restart:hover {
  @media (hover: hover) {
    text-decoration: none;
    background-color: #eeeeee;
  }
}

@include breakpoint(medium) {
  #configurator {
    width: auto;
    margin: 0;
    // margin-bottom: 10px;
  }
}

@include breakpoint(small) {
  #configurator {
    width: auto;
    margin: 0;
    margin-top: 0px;
  }


  #configurator:before {
    height: 900px;
  }

  #configurator-box.wrapper {
    margin: 0 auto;
    max-height: 100%;
  }

  #configurator-box.wrapper .inner-wrapper {
    height:100%;
  }

  #configurator-content {
    height: 100%;
  }

}


@include breakpoint(frommediumlarge) {

  #step-email, #step-valuation {
    width: 720px;
  }
}


@include breakpoint(fromgiant) {
  #step-email, #step-valuation {
    width: 960px;
  }
}


@include breakpoint(extralarge) {
  #step-email, #step-valuation {
    width: 1112px;
  }
}

@media screen and (min-width:1200px) and (max-height:850px) {
  #configurator h3 {
    font-size:32px;
    line-height:40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Configurator.vue